const production = true;
const key1 = {
    apiKey: "AIzaSyAcJVHxAxk9DJWzXeEltzSRT-Jv3_ZSIqo",
    authDomain: "tidziwe-system.firebaseapp.com",
    databaseURL: "https://tidziwe-system-default-rtdb.firebaseio.com",
    projectId: "tidziwe-system",
    storageBucket: "tidziwe-system.appspot.com",
    messagingSenderId: "357032884419",
    appId: "1:357032884419:web:7007481b840b1364164a76",
    measurementId: "G-6RFN3E52KZ"
};
const key2 = {
    apiKey: "AIzaSyAcJVHxAxk9DJWzXeEltzSRT-Jv3_ZSIqo",
      authDomain: "tidziwe-system.firebaseapp.com",
      databaseURL: "https://tidziwe-system-default-rtdb.firebaseio.com",
      projectId: "tidziwe-system",
      storageBucket: "tidziwe-system.appspot.com",
      messagingSenderId: "357032884419",
      appId: "1:357032884419:web:7007481b840b1364164a76",
      measurementId: "G-6RFN3E52KZ"
};
const SERVER_LINK = "https://us-central1-tidziwe-system.cloudfunctions.net/"
const SERVER_LINK2 = "https://us-central1-tidziwe-system.cloudfunctions.net/"

const ADMIN_PHONE = "+265993259202"
const APP ={ 
    VERSION:'0.0.2',
    NAME:"Tidziwe",
    SERVER:"TDZ",
    SERVER2:"TDZ",
    SERVER_LINK:production?SERVER_LINK2:SERVER_LINK, 
    SERVER_VERSION:57,
    CODE_VERSION:17,
    EMAIL_SERVER:"@tidziwe.com",
    POWERED_BY:"Powered by mHub",

    ACTION_REFRESH_TIME:100,
    ALLOWED_HOLD_TIME:10000,
    LINK:"https://mbspos.web.app/",
    EMAIL:"regisjearmbera@gmail.com",
    ADMIN_EMAIL:"admin@tidziwe.com", 
    ADMIN_PHONE:ADMIN_PHONE, 
    DEFAULT_PASSWORD:'123456789',
    CC_EMAIL:"",
    key:production?key2:key1,
    // key:key1,
    // key:key2,
    USER_TIMELINE:{
        current:'CURRENT_USER',
        action_request:'ACTION_REQUEST_USER',
        logged_out:'LOGGED_OUT_USER',
    }
}; 
const CODE = {
    timestamp:"TIMESTAMP", 
    system:"SYSTEM_CODE",
}  
const PAY_DOMAINS ={   
    ngenius:"https://api-gateway.sandbox.ngenius-payments.com/",  
    standardbank:"https://api-gateway.sandbox.standardbank.co.mw/",  
};
 
const FIELDS = {   
    //people
    add_user:[ 
        {type:"autocomplete",value:"user",label:"Select User",label_top:"User Phone Number*",
        select:{
            name:'Users',
            value:(item)=>{return item},
            text:'phone_number'
        },
        search:{
            filter:(item, queryText, itemText) => { 
                let index = (a,b)=>{
                    if(!a||!b){return false}
                    a = ""+a; b = ""+b
                    return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                } 
                let first = index(itemText,queryText)
                let second = item?index(item.names,queryText):false
                let third = item?index(item.surname,queryText):false
                if(!item){return first} 
                return first || second  || third 
            },
            item_icon:{
                name:'mdi-account'
            },
            item_title:['phone_number'],
            item_subtitle:['names','surname']
        },
        action:[ 
            { 
                item_values:"users",
                name:"Register User",
                link:"/settings/roles/register-user",
                company_link:true,
                append:true
            }
        ],required:true,sm:12,md:6},  
        {type:"autocomplete",value:"company_user_group_code",label:"Select Role",label_top:"User Role*",select:{
            name:'UserGroups',
            value:'code',
            text:'name'
        },action:[
            { 
                action:"add_item",
                item_values:"user_groups",
                name:"Add New Role",
                append:true
            },{ 
                action:"add_item",
                item_values:"user_groups",
                action_name:"Add", 
                name:" as New Role", 
            },{ 
                item_values:"user_groups",
                name:"Manage User Roles",
                link:"/settings/roles/user-roles",
                company_link:true,
                append:true
            }
        ],required:true,sm:12,md:6},      
    ],
    edit_user:[ 
        {type:"autocomplete",value:"user",disabled:true,label:"Select User",label_top:"User Phone Number*",
        select:{
            name:'Users',
            value:"key",
            text:'phone_number'
        },
        search:{
            filter:(item, queryText, itemText) => { 
                let index = (a,b)=>{
                    if(!a||!b){return false}
                    a = ""+a; b = ""+b
                    return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                } 
                let first = index(itemText,queryText)
                let second = item?index(item.code,queryText):false
                if(!item){return first} 
                return first || second 
            },
            item_icon:{
                name:'mdi-account'
            },
            item_title:['name'],
            item_subtitle:['code']
        },
        action:[ 
            { 
                item_values:"users",
                name:"Register User",
                link:"/settings/roles/register-user",
                company_link:true,
                append:true
            }
        ],required:true,sm:12,md:6},  
        {type:"autocomplete",value:"company_user_group_code",label:"Select Role",label_top:"User Role*",select:{
            name:'UserGroups',
            value:'code',
            text:'name'
        },action:[
            { 
                action:"add_item",
                item_values:"user_groups",
                name:"Add New Role",
                append:true
            },{ 
                action:"add_item",
                item_values:"user_groups",
                action_name:"Add", 
                name:" as New Role", 
            },{ 
                item_values:"user_groups",
                name:"Manage User Roles",
                link:"/settings/roles/user-roles",
                company_link:true,
                append:true
            }
        ],required:true,sm:12,md:6},      
    ], 

    reporters:[
        {type:"",value:"code",label:"Code",label_top:"Tracking Number*",
            auto_code:{
                values:CODE.system, 
                onstart:true,
                disabledIfCode:true
            },
        required:true,sm:12,md:6},  
        {type:"gender",value:"gender",label:"Gender",label_top:"Reporter's Gender",required:false,sm:12,md:6},      
        {type:"text",value:"first_name",label:"Enter First Name",label_top:"Reporter First Name*",required:true,sm:12,md:6},
        {type:"text",value:"last_name",label:"Enter Last Name",label_top:"Reporter Last Name*",required:true,sm:12,md:6},
        {type:"autocomplete",value:"reporter_category_code",label:"Select",label_top:"Category*",
            select:{
                name:'ReporterCategories',
                value:'code',
                text:'name'
            },
            search:{
                filter:(item, queryText, itemText) => { 
                    let index = (a,b)=>{
                        if(!a||!b){return false}
                        a = ""+a; b = ""+b
                        return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                    } 
                    let first = index(itemText,queryText)
                    let second = item?index(item.code,queryText):false
                    if(!item){return first} 
                    return first || second 
                },
                item_icon:{
                    name:'mdi-account'
                },
                item_title:['name'],
                item_subtitle:['code']
            }, 
        required:true,sm:12,md:6},   
        {type:"text",value:"email_address",label:"Email",label_top:"Customer Email Address (Optional)",required:false,sm:12,md:6},   
        {type:"text",value:"phone_number",label:"Phone",label_top:"Customer Phone Number (Optional)",required:false,sm:12,md:6},   
        {type:"text",value:"location_address",label:"Location",label_top:"Location Address",required:false,sm:12,md:6},  
        {type:"password",value:"password",label:"Password",label_top:"User Password",required:true,sm:12,md:12},  
    ],  
    //QUESTION CATEGORY
    
    reporter_categories:[
        {type:"",value:"code",label:"Code",label_top:"Tracking Number*",
            auto_code:{
                values:CODE.system, 
                onstart:true,
                disabledIfCode:true
            },
        required:true,sm:12,md:12},     
        {type:"text",value:"name",label:"Enter Name",label_top:"Category Name*",required:true,sm:12,md:12},  
    ], 
    question_categories:[
        {type:"",value:"code",label:"Code",label_top:"Tracking Number*",
            auto_code:{
                values:CODE.system, 
                onstart:true,
                disabledIfCode:true
            },
        required:true,sm:12,md:12},     
        {type:"text",value:"name",label:"Enter Name",label_top:"Category Name*",required:true,sm:12,md:12},  
    ], 
    question_types:[
        {type:"",value:"code",label:"Code",label_top:"Tracking Number*",
            auto_code:{
                values:CODE.system, 
                onstart:true,
                disabledIfCode:true
            },
        required:true,sm:12,md:12},     
        {type:"text",value:"name",label:"Enter Name",label_top:"Type Name*",required:true,sm:12,md:12},  
    ], 
    question_timelines:[
        {type:"",value:"code",label:"Code",label_top:"Tracking Number*",
            auto_code:{
                values:CODE.system, 
                onstart:true,
                disabledIfCode:true
            },
        required:true,sm:12,md:12},     
        {type:"text",value:"name",label:"Enter Name",label_top:"Timeline Name*",required:true,sm:12,md:12},  
        {type:"time",value:"starting_time",label:"Enter time",label_top:"Stating Time*",required:true,sm:12,md:6},  
        {type:"time",value:"ending_time",label:"Enter time",label_top:"Ending Time*",required:true,sm:12,md:6},  
    ], 
    question_stages:[
        {type:"",value:"code",label:"Code",label_top:"Tracking Number*",
            auto_code:{
                values:CODE.system, 
                onstart:true,
                disabledIfCode:true
            },
        required:true,sm:12,md:12},     
        {type:"text",value:"name",label:"Enter Name",label_top:"Timeline Name*",required:true,sm:12,md:12},  
        {type:"date",value:"starting_date",label:"Enter Date",label_top:"Stating Date*",required:true,sm:12,md:6},  
        {type:"date",value:"ending_date",label:"Enter Date",label_top:"Ending Date*",required:true,sm:12,md:6},  
    ], 
    questionnaires:[
        {type:"",value:"code",label:"Code",label_top:"Tracking Number*",
            auto_code:{
                values:CODE.system, 
                onstart:true,
                disabledIfCode:true
            },
        required:true,sm:12,md:6},  
        {type:"text",value:"question_number",label:"Enter Number",label_top:"Question Number*",required:true,sm:12,md:6}, 
        {type:"text",value:"question_body",label:"Enter Question",label_top:"Question*",required:true,sm:12,md:12}, 
        {type:"text",value:"question_tag",label:"Enter Tag",label_top:"Question Tag*",required:true,sm:12,md:6}, 
        {type:"text",value:"question_tag_value",label:"Enter Tag",label_top:"Question Tag Value*",required:true,sm:12,md:6},
        {type:"text",value:"question_predefined_answer",label:"Enter Answer",label_top:"Question Predefined Answer (Optional)",required:false,sm:12,md:12},    
        {type:"autocomplete",value:"question_category_code",label:"Select Category",label_top:"Question Category*",
            select:{
                name:'QuestionCategories',
                value:'code',
                text:'name'
            },
            search:{
                filter:(item, queryText, itemText) => { 
                    let index = (a,b)=>{
                        if(!a||!b){return false}
                        a = ""+a; b = ""+b
                        return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                    } 
                    let first = index(itemText,queryText)
                    let second = item?index(item.code,queryText):false
                    if(!item){return first} 
                    return first || second 
                },
                item_icon:{
                    name:'mdi-account'
                },
                item_title:['name'],
                item_subtitle:['code']
            }, 
        required:true,sm:12,md:6},    
        {type:"autocomplete",value:"question_type_code",label:"Select Type",label_top:"Question Type*",
            select:{
                name:'QuestionTypes',
                value:'code',
                text:'name'
            },
            search:{
                filter:(item, queryText, itemText) => { 
                    let index = (a,b)=>{
                        if(!a||!b){return false}
                        a = ""+a; b = ""+b
                        return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                    } 
                    let first = index(itemText,queryText)
                    let second = item?index(item.code,queryText):false
                    if(!item){return first} 
                    return first || second 
                },
                item_icon:{
                    name:'mdi-account'
                },
                item_title:['name'],
                item_subtitle:['code']
            }, 
        required:true,sm:12,md:6},   
        {type:"autocomplete",value:"question_timeline_code",label:"Select Timeline",label_top:"Question Timeline*",
            select:{
                name:'QuestionTimelines',
                value:'code',
                text:'name'
            },
            search:{
                filter:(item, queryText, itemText) => { 
                    let index = (a,b)=>{
                        if(!a||!b){return false}
                        a = ""+a; b = ""+b
                        return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                    } 
                    let first = index(itemText,queryText)
                    let second = item?index(item.code,queryText):false
                    if(!item){return first} 
                    return first || second 
                },
                item_icon:{
                    name:'mdi-account'
                },
                item_title:['name'],
                item_subtitle:['code']
            }, 
        required:true,sm:12,md:6},   
        {type:"autocomplete",value:"occurrence_code",label:"Select",label_top:"Occurrence*",
            select:{
                name:'Occurrences',
                value:'code',
                text:'name'
            },
            search:{
                filter:(item, queryText, itemText) => { 
                    let index = (a,b)=>{
                        if(!a||!b){return false}
                        a = ""+a; b = ""+b
                        return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                    } 
                    let first = index(itemText,queryText)
                    let second = item?index(item.code,queryText):false
                    if(!item){return first} 
                    return first || second 
                },
                item_icon:{
                    name:'mdi-account'
                },
                item_title:['name'],
                item_subtitle:['code']
            }, 
        required:true,sm:12,md:6},   
        {type:"yes_or_no",value:"question_has_explanation",label:"Has Explanation",label_top:"Question Has Explanation*",required:true,sm:12,md:12},   
        
    ], 
    occurrences:[
        {type:"",value:"code",label:"Code",label_top:"Tracking Number*",
            auto_code:{
                values:CODE.system, 
                onstart:true,
                disabledIfCode:true
            },
        required:true,sm:12,md:6},     
        {type:"text",value:"name",label:"Enter Name",label_top:"Occurrence Name*",required:true,sm:12,md:6}, 
        {type:"textarea",value:"description",label:"Enter a note",label_top:"Description (Optional)",required:false,sm:12,md:12},   
    ], 
    create_reports:[
        {type:"",value:"code",label:"Code",label_top:"Tracking Number*",
            auto_code:{
                values:CODE.system, 
                onstart:true,
                disabledIfCode:true
            },
        required:true,sm:12,md:6},  
        {type:"autocomplete",value:"occurrence_code",label:"Select",label_top:"Occurrence*",
            select:{
                name:'Occurrences',
                value:'code',
                text:'name'
            },
            search:{
                filter:(item, queryText, itemText) => { 
                    let index = (a,b)=>{
                        if(!a||!b){return false}
                        a = ""+a; b = ""+b
                        return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                    } 
                    let first = index(itemText,queryText)
                    let second = item?index(item.code,queryText):false
                    if(!item){return first} 
                    return first || second 
                },
                item_icon:{
                    name:'mdi-account'
                },
                item_title:['name'],
                item_subtitle:['code']
            }, 
        required:true,sm:12,md:6},  
        
        {type:"autocomplete",value:"district_code",label:"Select District",label_top:"Reporting District*",
            select:{
                name:'Districts',
                value:'code',
                text:'name'
            },
            search:{
                filter:(item, queryText, itemText) => { 
                    let index = (a,b)=>{
                        if(!a||!b){return false}
                        a = ""+a; b = ""+b
                        return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                    } 
                    let first = index(itemText,queryText)
                    let second = item?index(item.code,queryText):false
                    if(!item){return first} 
                    return first || second 
                },
                item_icon:{
                    name:'mdi-account'
                },
                item_title:['name'],
                item_subtitle:['code']
            }, 
        required:true,sm:12,md:12},   
        {type:"autocomplete",value:"tradition_authority_code",label:"Select",label_top:"Tradition Authority*",
            select:{
                name:'TraditionAuthorities',
                filter:{input:"district_code",name:'Districts'},
                value:'code',
                text:'name'
            },
            search:{
                filter:(item, queryText, itemText) => { 
                    let index = (a,b)=>{
                        if(!a||!b){return false}
                        a = ""+a; b = ""+b
                        return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                    } 
                    let first = index(itemText,queryText)
                    let second = item?index(item.code,queryText):false
                    if(!item){return first} 
                    return first || second 
                },
                item_icon:{
                    name:'mdi-account'
                },
                item_title:['name'],
                item_subtitle:['code']
            }, 
        required:true,sm:12,md:6},   
        {type:"autocomplete",value:"constituency_code",label:"Select ",label_top:"Constituency*",
            select:{
                name:'Constituencies',
                filter:{input:"district_code",name:'Districts'},
                value:'code',
                text:'name'
            },
            search:{
                filter:(item, queryText, itemText) => { 
                    let index = (a,b)=>{
                        if(!a||!b){return false}
                        a = ""+a; b = ""+b
                        return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                    } 
                    let first = index(itemText,queryText)
                    let second = item?index(item.code,queryText):false
                    if(!item){return first} 
                    return first || second 
                },
                item_icon:{
                    name:'mdi-account'
                },
                item_title:['name'],
                item_subtitle:['code']
            }, 
        required:true,sm:12,md:6},   
        {type:"autocomplete",value:"ward_code",label:"Select",label_top:"Ward*",
            select:{
                name:'Wards',
                filter:{input:"constituency_code",name:'Constituencies'},
                value:'code',
                text:'name'
            },
            search:{
                filter:(item, queryText, itemText) => { 
                    let index = (a,b)=>{
                        if(!a||!b){return false}
                        a = ""+a; b = ""+b
                        return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                    } 
                    let first = index(itemText,queryText)
                    let second = item?index(item.code,queryText):false
                    if(!item){return first} 
                    return first || second 
                },
                item_icon:{
                    name:'mdi-account'
                },
                item_title:['name'],
                item_subtitle:['code']
            }, 
        required:true,sm:12,md:6},  
        {type:"autocomplete",value:"centre_code",label:"Select",label_top:"Centre*",
            select:{
                name:'Centres',
                filter:{input:"ward_code",name:'Wards'},
                value:'code',
                text:'name'
            },
            search:{
                filter:(item, queryText, itemText) => { 
                    let index = (a,b)=>{
                        if(!a||!b){return false}
                        a = ""+a; b = ""+b
                        return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                    } 
                    let first = index(itemText,queryText)
                    let second = item?index(item.code,queryText):false
                    if(!item){return first} 
                    return first || second 
                },
                item_icon:{
                    name:'mdi-account'
                },
                item_title:['name'],
                item_subtitle:['code']
            }, 
        required:true,sm:12,md:6},  
    ],
    select_centres:[  
        {type:"autocomplete",value:"district_code",label:"Select District",label_top:"Reporting District*",
            select:{
                name:'Districts',
                value:'code',
                text:'name'
            },
            search:{
                filter:(item, queryText, itemText) => { 
                    let index = (a,b)=>{
                        if(!a||!b){return false}
                        a = ""+a; b = ""+b
                        return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                    } 
                    let first = index(itemText,queryText)
                    let second = item?index(item.code,queryText):false
                    if(!item){return first} 
                    return first || second 
                },
                item_icon:{
                    name:'mdi-account'
                },
                item_title:['name'],
                item_subtitle:['code']
            }, 
        required:true,sm:12,md:12},   
        {type:"autocomplete",value:"tradition_authority_code",label:"Select",label_top:"Tradition Authority*",
            select:{
                name:'TraditionAuthorities',
                filter:{input:"district_code",name:'Districts'},
                value:'code',
                text:'name'
            },
            search:{
                filter:(item, queryText, itemText) => { 
                    let index = (a,b)=>{
                        if(!a||!b){return false}
                        a = ""+a; b = ""+b
                        return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                    } 
                    let first = index(itemText,queryText)
                    let second = item?index(item.code,queryText):false
                    if(!item){return first} 
                    return first || second 
                },
                item_icon:{
                    name:'mdi-account'
                },
                item_title:['name'],
                item_subtitle:['code']
            }, 
        required:true,sm:12,md:6},   
        {type:"autocomplete",value:"constituency_code",label:"Select ",label_top:"Constituency*",
            select:{
                name:'Constituencies',
                filter:{input:"district_code",name:'Districts'},
                value:'code',
                text:'name'
            },
            search:{
                filter:(item, queryText, itemText) => { 
                    let index = (a,b)=>{
                        if(!a||!b){return false}
                        a = ""+a; b = ""+b
                        return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                    } 
                    let first = index(itemText,queryText)
                    let second = item?index(item.code,queryText):false
                    if(!item){return first} 
                    return first || second 
                },
                item_icon:{
                    name:'mdi-account'
                },
                item_title:['name'],
                item_subtitle:['code']
            }, 
        required:true,sm:12,md:6},   
        {type:"autocomplete",value:"ward_code",label:"Select",label_top:"Ward*",
            select:{
                name:'Wards',
                filter:{input:"constituency_code",name:'Constituencies'},
                value:'code',
                text:'name'
            },
            search:{
                filter:(item, queryText, itemText) => { 
                    let index = (a,b)=>{
                        if(!a||!b){return false}
                        a = ""+a; b = ""+b
                        return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                    } 
                    let first = index(itemText,queryText)
                    let second = item?index(item.code,queryText):false
                    if(!item){return first} 
                    return first || second 
                },
                item_icon:{
                    name:'mdi-account'
                },
                item_title:['name'],
                item_subtitle:['code']
            }, 
        required:true,sm:12,md:6},  
        {type:"autocomplete",value:"centre_code",label:"Select",label_top:"Centre*",
            select:{
                name:'Centres',
                filter:{input:"ward_code",name:'Wards'},
                value:'code',
                text:'name'
            },
            search:{
                filter:(item, queryText, itemText) => { 
                    let index = (a,b)=>{
                        if(!a||!b){return false}
                        a = ""+a; b = ""+b
                        return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                    } 
                    let first = index(itemText,queryText)
                    let second = item?index(item.code,queryText):false
                    if(!item){return first} 
                    return first || second 
                },
                item_icon:{
                    name:'mdi-account'
                },
                item_title:['name'],
                item_subtitle:['code']
            }, 
        required:true,sm:12,md:6},  
    ], 
    
    //LOCATIONS
    countries:[
        {type:"",value:"code",label:"Code",label_top:"Tracking Number*",
            auto_code:{
                values:CODE.system, 
                onstart:true,
                disabledIfCode:true
            },
        required:true,sm:12,md:6},     
        {type:"text",value:"name",label:"Enter Name",label_top:"Country Name*",required:true,sm:12,md:6}, 
        {type:"textarea",value:"description",label:"Enter a note",label_top:"Description (Optional)",required:false,sm:12,md:12},   
    ], 
    regions:[
        {type:"",value:"code",label:"Code",label_top:"Tracking Number*",
            auto_code:{
                values:CODE.system, 
                onstart:true,
                disabledIfCode:true
            },
        required:true,sm:12,md:6},  
        {type:"text",value:"name",label:"Enter Name",label_top:"Region Name*",required:true,sm:12,md:6}, 
        {type:"autocomplete",value:"country_code",label:"Select Country",label_top:"Country *",
            select:{
                name:'Countries',
                value:'code',
                text:'name'
            },
            search:{
                filter:(item, queryText, itemText) => { 
                    let index = (a,b)=>{
                        if(!a||!b){return false}
                        a = ""+a; b = ""+b
                        return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                    } 
                    let first = index(itemText,queryText)
                    let second = item?index(item.code,queryText):false
                    if(!item){return first} 
                    return first || second 
                },
                item_icon:{
                    name:'mdi-account'
                },
                item_title:['name'],
                item_subtitle:['code']
            }, 
        required:true,sm:12,md:12},    
        {type:"textarea",value:"description",label:"Enter a note",label_top:"Description (Optional)",required:false,sm:12,md:12},   
    ], 
    districts:[
        {type:"",value:"code",label:"Code",label_top:"Tracking Number*",
            auto_code:{
                values:CODE.system, 
                onstart:true,
                disabledIfCode:true
            },
        required:true,sm:12,md:6},  
        {type:"text",value:"name",label:"Enter Name",label_top:"District Name*",required:true,sm:12,md:6}, 
        {type:"autocomplete",value:"region_code",label:"Select Region",label_top:"Region *",
            select:{
                name:'Regions',
                value:'code',
                text:'name'
            },
            search:{
                filter:(item, queryText, itemText) => { 
                    let index = (a,b)=>{
                        if(!a||!b){return false}
                        a = ""+a; b = ""+b
                        return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                    } 
                    let first = index(itemText,queryText)
                    let second = item?index(item.code,queryText):false
                    if(!item){return first} 
                    return first || second 
                },
                item_icon:{
                    name:'mdi-account'
                },
                item_title:['name'],
                item_subtitle:['code']
            }, 
        required:true,sm:12,md:12},     
        {type:"textarea",value:"description",label:"Enter a note",label_top:"Description (Optional)",required:false,sm:12,md:12},   
    ], 
    constituencies:[
        {type:"",value:"code",label:"Code",label_top:"Tracking Number*",
            auto_code:{
                values:CODE.system, 
                onstart:true,
                disabledIfCode:true
            },
        required:true,sm:12,md:6},  
        {type:"text",value:"name",label:"Enter Name",label_top:"Constituency Name*",required:true,sm:12,md:6}, 
        {type:"autocomplete",value:"district_code",label:"Select District",label_top:"District *",
            select:{
                name:'Districts',
                value:'code',
                text:'name'
            },
            search:{
                filter:(item, queryText, itemText) => { 
                    let index = (a,b)=>{
                        if(!a||!b){return false}
                        a = ""+a; b = ""+b
                        return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                    } 
                    let first = index(itemText,queryText)
                    let second = item?index(item.code,queryText):false
                    if(!item){return first} 
                    return first || second 
                },
                item_icon:{
                    name:'mdi-account'
                },
                item_title:['name'],
                item_subtitle:['code']
            }, 
        required:true,sm:12,md:12},     
        {type:"textarea",value:"description",label:"Enter a note",label_top:"Description (Optional)",required:false,sm:12,md:12},   
    ], 
    wards:[
        {type:"",value:"code",label:"Code",label_top:"Tracking Number*",
            auto_code:{
                values:CODE.system, 
                onstart:true,
                disabledIfCode:true
            },
        required:true,sm:12,md:6},  
        {type:"text",value:"name",label:"Enter Name",label_top:"Ward Name*",required:true,sm:12,md:6}, 
        {type:"autocomplete",value:"constituency_code",label:"Select Constituency",label_top:"Constituency *",
            select:{
                name:'Constituencies',
                value:'code',
                text:'name'
            },
            search:{
                filter:(item, queryText, itemText) => { 
                    let index = (a,b)=>{
                        if(!a||!b){return false}
                        a = ""+a; b = ""+b
                        return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                    } 
                    let first = index(itemText,queryText)
                    let second = item?index(item.code,queryText):false
                    if(!item){return first} 
                    return first || second 
                },
                item_icon:{
                    name:'mdi-account'
                },
                item_title:['name'],
                item_subtitle:['code']
            }, 
        required:true,sm:12,md:12},     
        {type:"textarea",value:"description",label:"Enter a note",label_top:"Description (Optional)",required:false,sm:12,md:12},   
    ], 
    centres:[
        {type:"",value:"code",label:"Code",label_top:"Tracking Number*",
            auto_code:{
                values:CODE.system, 
                onstart:true,
                disabledIfCode:true
            },
        required:true,sm:12,md:6},  
        {type:"text",value:"name",label:"Enter Name",label_top:"Centre Name*",required:true,sm:12,md:6}, 
        {type:"autocomplete",value:"ward_code",label:"Select Ward",label_top:"Ward *",
            select:{
                name:'Wards',
                value:'code',
                text:'name'
            },
            search:{
                filter:(item, queryText, itemText) => { 
                    let index = (a,b)=>{
                        if(!a||!b){return false}
                        a = ""+a; b = ""+b
                        return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                    } 
                    let first = index(itemText,queryText)
                    let second = item?index(item.code,queryText):false
                    if(!item){return first} 
                    return first || second 
                },
                item_icon:{
                    name:'mdi-account'
                },
                item_title:['name'],
                item_subtitle:['code']
            }, 
        required:true,sm:12,md:12},     
        {type:"textarea",value:"description",label:"Enter a note",label_top:"Description (Optional)",required:false,sm:12,md:12},   
    ],  
    tradition_authorities:[
        {type:"",value:"code",label:"Code",label_top:"Tracking Number*",
            auto_code:{
                values:CODE.system, 
                onstart:true,
                disabledIfCode:true
            },
        required:true,sm:12,md:6},  
        {type:"text",value:"name",label:"Enter Name",label_top:"TA Name*",required:true,sm:12,md:6}, 
        {type:"autocomplete",value:"district_code",label:"Select District",label_top:"District *",
            select:{
                name:'Districts',
                value:'code',
                text:'name'
            },
            search:{
                filter:(item, queryText, itemText) => { 
                    let index = (a,b)=>{
                        if(!a||!b){return false}
                        a = ""+a; b = ""+b
                        return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                    } 
                    let first = index(itemText,queryText)
                    let second = item?index(item.code,queryText):false
                    if(!item){return first} 
                    return first || second 
                },
                item_icon:{
                    name:'mdi-account'
                },
                item_title:['name'],
                item_subtitle:['code']
            }, 
        required:true,sm:12,md:12},     
        {type:"textarea",value:"description",label:"Enter a note",label_top:"Description (Optional)",required:false,sm:12,md:12},   
    ], 
 

    //cpanel
    user_groups:[
        {type:"",name:"code",value:"code",label:"Code",
        auto_code:{
            values:CODE.system, 
            onstart:false,
            disabledIfCode:true
        },required:true,sm:12,md:6}, 
        {type:"text",name:"name",value:"name",label:"Name",required:true,sm:12,md:6},  
    ],  
    permissions:[
        {type:"",name:"code",value:"code",label:"Code",
        auto_code:{
            values:CODE.system, 
            onstart:true,
            disabledIfCode:true
        },required:true,sm:12,md:12},  
        {type:"autocomplete",name:"name",value:"name",label:"name",required:true,sm:12,md:12,
            select:{
                name:'app_links',
                value:'name',
                text:'name'
            },
            search:{
                filter:(item, queryText, itemText) => { 
                    let index = (a,b)=>{
                        if(!a||!b){return false}
                        a = ""+a; b = ""+b
                        return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                    } 
                    let first = index(itemText,queryText)
                    let second = item?index(item.link,queryText):false
                    if(!item){return first} 
                    return first || second 
                },
                item_icon:{
                    name:'',
                    tile:true
                },
                item_title:['name'],
                item_subtitle:['path']
            },
        },  
        {type:"select",name:"type",value:"permission_type",label:"Action Type",required:true,sm:12,md:6,select:{
            name:'permission_type',
            value:'name',
            text:'name'
        }},  
        {type:"select",name:"type",value:"access_type",label:"Access Type",required:true,sm:12,md:6,select:{
            name:'access_type',
            value:'name',
            text:'name'
        }},  
    ], 
}
const ITEMS ={ 
    ERRORS: {
        names: 'Errors',
        name: 'Error',
        values: 'errors',
        value: 'error',
    },
    NOTIFICATIONS: {
        names: 'Notifications',
        name: 'Notification',
        values: 'notifications',
        value: 'notification',
    },
    ONLINE_STATUSES: {
        names: 'Online Statuses',
        name: 'Online Status',
        values: 'online_statuses',
        value: 'online_status',
    },
    USERS: {
        names: 'Users',
        name: 'User',
        values: 'users',
        value: 'user',
    },
    USER_STATUSES: {
        names: 'User Statuses',
        name: 'User Status',
        values: 'user_statuses',
        value: 'user_status',
    },
    USER_LIVES: {
        names: 'User Lives',
        name: 'User Live',
        values: 'user_lives',
        value: 'user_live',
    },
    USER_DETAILS: {
        names: 'User Details',
        name: 'User Detail',
        values: 'user_details',
        value: 'user_detail',
    },
    USER_GROUPS: {
        names: 'User groups',
        name: 'User group',
        values: 'user_groups',
        value: 'user_group',
    },
    VISITERS: {
        names: 'Visiters',
        name: 'Visiter',
        values: 'visiters',
        value: 'visiter',
    },
    PERMISSIONS: {
        names: 'Permissions',
        name: 'Permission',
        values: 'permissions',
        value: 'permission',
    },
    MESSAGES: {
        names: 'Messages',
        name: 'Message',
        values: 'messages',
        value: 'message',
    },
    ACCESS_KEYS: {
        names: 'Access Keys',
        name: 'Access Key',
        values: 'access_keys',
        value: 'access_key',
    }, 
    ID_TYPES: {
        names: 'ID Types',
        name: 'ID Type',
        values: 'id_types',
        value: 'id_type',
    }, 
    ACTION_HOLDERS: {
        names: 'Action Holders',
        name: 'Action Holder',
        values: 'action_holders',
        value: 'action_holder',
    },
    REFUND_POLICE: {
        names: 'Refund Polices',
        name: 'Refund Police',
        values: 'refund_polices',
        value: 'refund_police',
    },
    CANCELLATION_FEES: {
        names: 'Cancellation Fees',
        name: 'Cancellation Fee',
        values: 'cancellation_fees',
        value: 'cancellation_fee',
    },
    MEASUREMENT_UNITS: {
        names: 'Measurement Units',
        name: 'Measurement Unit',
        values: 'measurement_units',
        value: 'measurement_unit',
    }, 
    TRACKING_KEYS: {
        names: 'Tracking Keys',
        name: 'Tracking Key',
        values: 'tracking_keys',
        value: 'tracking_key',
    },  
    TRACKING_UPDATES: {
        names: 'Tracking Updates',
        name: 'Tracking Update',
        values: 'tracking_updates',
        value: 'tracking_update',
    },   
    OLD_DATA: {
        names: 'Old Data',
        name: 'Old Data',
        values: 'old_data',
        value: 'old_data  ',
    }, 


    //LOCATION
    LOCATIONS: {
        names: 'Locations',
        name: 'Location',
        values: 'locations',
        value: 'location',
    },
    COUNTRIES: {
        names: 'Countries',
        name: 'Country',
        values: 'countries',
        value: 'country',
    },
    REGIONS: {
        names: 'Regions',
        name: 'Regions',
        values: 'regions',
        value: 'regions',
    },
    DISTRICTS: {
        names: 'Districts',
        name: 'District',
        values: 'districts',
        value: 'district',
    },
    CONSTITUENCIES: {
        names: 'Constituencies',
        name: 'Constituency',
        values: 'constituencies',
        value: 'constituency',
    },
    WARDS: {
        names: 'Wards',
        name: 'Ward',
        values: 'wards',
        value: 'ward',
    },
    CENTRES: {
        names: 'Centres',
        name: 'Centre',
        values: 'centres',
        value: 'centre',
    },
    TRADITION_AUTHORITIES: {
        names: 'Tradition Authorities',
        name: 'Tradition Authority',
        values: 'tradition_authorities',
        value: 'tradition_authority',
    },
     
     
    
    //CUSTOM
    ITEMS: {
        names: 'Items',
        name: 'Item',
        values: 'items',
        value: 'item',
    }, 
    QUESTIONS: {
        names: 'Questions',
        name: 'Question',
        values: 'questions',
        value: 'question',
    },
    QUESTION_TYPES: {
        names: 'Question Types',
        name: 'Question Type',
        values: 'question_types',
        value: 'question_type',
    },
    QUESTION_CATEGORIES: {
        names: 'Question Categories',
        name: 'Question Category',
        values: 'question_categories',
        value: 'question_category',
    },
    QUESTION_TIMELINES: {
        names: 'Question Timelines',
        name: 'Question Timeline',
        values: 'question_timelines',
        value: 'question_timeline',
    },
    QUESTION_STAGES: {
        names: 'Question Stages',
        name: 'Question Stage',
        values: 'question_stages',
        value: 'question_stage',
    },
    QUESTIONNAIRES: {
        names: 'Questionnaires',
        name: 'Questionnaire',
        values: 'questionnaires',
        value: 'questionnaire',
    },
    REPORTS: {
        names: 'Reports',
        name: 'Report',
        values: 'reports',
        value: 'report',
    },
    WEB_REPORTS: {
        names: 'Web Reports',
        name: 'Web Report',
        values: 'web_reports',
        value: 'web_report',
    },
    SMS_REPORTS: {
        names: 'SMS Reports',
        name: 'SMS Report',
        values: 'sms_reports',
        value: 'sms_report',
    },
    WHATSAPP_REPORTS: {
        names: 'Whatsapp Reports',
        name: 'Whatsapp Report',
        values: 'whatsapp_reports',
        value: 'whatsapp_report',
    },
    PERSONAL_REPORTS: {
        names: 'Personal Reports',
        name: 'Personal Report',
        values: 'personal_reports',
        value: 'personal_report',
    },
    ANSWER_PERSONAL_REPORTS: {
        names: 'Answer Personal Reports',
        name: 'Answer Personal Report',
        values: 'answer_personal_reports',
        value: 'answer_personal_report',
    },
    MOBILE_REPORTS: {
        names: 'Mobile_Reports',
        name: 'Mobile_Report',
        values: 'mobile_reports',
        value: 'mobile_report',
    },
    REPORTERS: {
        names: 'Reporters',
        name: 'Reporter',
        values: 'reporters',
        value: 'reporter',
    },
    REPORTER_CATEGORIES: {
        names: 'Reporter Categories',
        name: 'Reporter Category',
        values: 'reporter_categories',
        value: 'reporter_category',
    },
    OCCURRENCES: {
        names: 'Interventions',
        name: 'Intervention',
        values: 'occurrences',
        value: 'occurrences',
    },
    TRACKINGS: {
        names: 'Trackings',
        name: 'Tracking',
        values: 'trackings',
        value: 'tracking',
    }, 
     
};
const data_path= (APP.SERVER+"/").toUpperCase()
const settings_path = data_path+"SETTINGS/" 
const settings_question_path = settings_path+(ITEMS.QUESTIONS.values.toUpperCase())+"/"
const settings_location_path = settings_path+(ITEMS.LOCATIONS.values.toUpperCase())+"/"
const PATHS = {
    users:(ITEMS.USERS.values+"/").toUpperCase(),
    
    //SETTINGS
    user_groups:settings_path+(ITEMS.USER_GROUPS.values.toUpperCase())+"/",
    permissions:settings_path+(ITEMS.PERMISSIONS.values.toUpperCase())+"/",
    occurrences:settings_path+(ITEMS.OCCURRENCES.values.toUpperCase())+"/",
    reporters:settings_path+(ITEMS.REPORTERS.values.toUpperCase())+"/",
    reporter_categories:settings_path+(ITEMS.REPORTER_CATEGORIES.values.toUpperCase())+"/",
    tracking_updates:settings_path+(ITEMS.TRACKINGS.values.toUpperCase())+"/UPDATES/",  

    //LOCATIONS
    countries:settings_location_path+(ITEMS.COUNTRIES.values.toUpperCase())+"/", 
    regions:settings_location_path+(ITEMS.REGIONS.values.toUpperCase())+"/", 
    districts:settings_location_path+(ITEMS.DISTRICTS.values.toUpperCase())+"/", 
    constituencies:settings_location_path+(ITEMS.CONSTITUENCIES.values.toUpperCase())+"/", 
    wards:settings_location_path+(ITEMS.WARDS.values.toUpperCase())+"/", 
    centres:settings_location_path+(ITEMS.CENTRES.values.toUpperCase())+"/", 
    tradition_authorities:settings_location_path+(ITEMS.TRADITION_AUTHORITIES.values.toUpperCase())+"/", 

    //Questions
    question_types:settings_question_path+(ITEMS.QUESTION_TYPES.values.toUpperCase())+"/", 
    question_categories:settings_question_path+(ITEMS.QUESTION_CATEGORIES.values.toUpperCase())+"/", 
    question_timelines:settings_question_path+(ITEMS.QUESTION_TIMELINES.values.toUpperCase())+"/", 
    question_stages:settings_question_path+(ITEMS.QUESTION_STAGES.values.toUpperCase())+"/", 

    //DATA
    items:data_path+(ITEMS.ITEMS.values.toUpperCase())+"/", 
    questionnaires:data_path+(ITEMS.QUESTIONNAIRES.values.toUpperCase())+"/", 
    reports:data_path+(ITEMS.REPORTERS.values.toUpperCase())+"/", 
    web_reports:data_path+(ITEMS.REPORTS.values.toUpperCase())+"/WEB/", 
    whatsapp_reports:data_path+(ITEMS.REPORTS.values.toUpperCase())+"/WHATSAPP/", 
    sms_reports:data_path+(ITEMS.REPORTS.values.toUpperCase())+"/SMS/", 
    mobile_reports:data_path+(ITEMS.REPORTS.values.toUpperCase())+"/MOBILE/", 
    personal_report:data_path+(ITEMS.REPORTS.values.toUpperCase())+"/PERSONAL/", 
    messages:data_path+(ITEMS.MESSAGES.values.toUpperCase())+"/",  
}  
 
module.exports = {
    //
    ACTION_REFRESH_TIME:100,
    APP:APP,
    CODE:CODE,  
    ITEMS:ITEMS, 
    FIELDS:FIELDS, 
    PATHS:PATHS,  
    production:production 
    //
};